import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, sessionToken } from "../lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch (e) {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // CRITICAL: If returning from OAuth callback, skip the /me check.
    // AuthCallback / MagicLinkConsume will exchange the token and establish the session first.
    if (window.location.hash?.includes("session_id=") || window.location.hash?.includes("token=")) {
      setLoading(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const logout = async () => {
    // Best-effort logout — if the network is offline or the session is already
    // expired the API call may fail; we still want to clear local state and
    // bounce the user to /login, so the error is intentionally swallowed.
    try { await api.post("/auth/logout"); } catch (e) { /* noop */ }
    sessionToken.clear();
    setUser(null);
    window.location.href = "/login";
  };

  return (
    <AuthContext.Provider value={{ user, setUser, loading, checkAuth, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
